import React from 'react';
import RolloverDetail from '../components/rollover/RolloverDetail';

const RolloverDetailPage = () => {
  return <RolloverDetail />;
};

export default RolloverDetailPage;